var map = {
	"./cosmic.scss": [
		"3686",
		"chunk-18a9a3b7"
	],
	"./dark-blue.scss": [
		"55dd",
		"chunk-1c19ea76"
	],
	"./dark.scss": [
		"ba7a",
		"chunk-6b3b889f"
	],
	"./default.scss": [
		"eca4",
		"chunk-7088b027"
	],
	"./light-orange.scss": [
		"056a",
		"chunk-137cbb06"
	],
	"./light-purple.scss": [
		"9401",
		"chunk-22c6d2b2"
	],
	"./light.scss": [
		"d770",
		"chunk-6c54a6c2"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "ba70";
module.exports = webpackAsyncContext;